import { render, staticRenderFns } from "./officeList.vue?vue&type=template&id=6d4a0460&scoped=true"
import script from "./officeList.vue?vue&type=script&lang=js"
export * from "./officeList.vue?vue&type=script&lang=js"
import style0 from "./officeList.vue?vue&type=style&index=0&id=6d4a0460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a0460",
  null
  
)

export default component.exports